import moment from "moment";
import { map, pipe, sort } from "ramda";
import {
  AuditLog,
  AuditLogChange,
  AuditLogChangeBase,
  AuditLogEntity,
  HistoryAuditLogs
} from "./types";

export interface FormattedAuditLogChange extends AuditLogChangeBase {
  newValue: number | undefined;
  originalValue: number | undefined;
  previousValue: number | undefined;
  timestamp: string;
}

export type FormattedAuditLog = FormattedAuditLogChange[];

export const buildFormattedAuditLog: (
  auditLog: AuditLog
) => FormattedAuditLog = pipe(
  map(
    (auditLogChange: AuditLogChange): FormattedAuditLogChange => ({
      changedByUser: auditLogChange.changedByUser,
      id: auditLogChange.id,
      reason: auditLogChange.reason,
      reasonText: auditLogChange.reasonText,
      valueId: auditLogChange.valueId,
      valueName: auditLogChange.valueName,
      valuePeriod: auditLogChange.valuePeriod,
      valueRemoved: auditLogChange.valueRemoved,
      valueType: auditLogChange.valueType,
      timestamp: auditLogChange.timestamp,

      newValue: auditLogChange.newValue
        ? parseFloat(auditLogChange.newValue)
        : undefined,
      previousValue: auditLogChange.previousValue
        ? parseFloat(auditLogChange.previousValue)
        : undefined,
      originalValue: auditLogChange.originalValue
        ? parseFloat(auditLogChange.originalValue)
        : undefined,
      fromParentNodeName: auditLogChange.fromParentNodeName,
      toParentNodeName: auditLogChange.toParentNodeName,
      isMappingChange: auditLogChange.isMappingChange
    })
  ),
  sort((a, b) => moment(b.timestamp).diff(moment(a.timestamp)))
);

export interface FormattedAuditLogEntityChange {
  auditLogEntryID: string | undefined;
  timestamp: string | undefined;
  logMessage: string | undefined;
  auditLogType: string | undefined;
}

export type FormattedAuditEntityLog = FormattedAuditLogEntityChange[];

export const buildFormattedAuditEntityLog: (
  auditLog: HistoryAuditLogs
) => FormattedAuditEntityLog = pipe(
  map(
    (auditLogEntity: AuditLogEntity): FormattedAuditLogEntityChange => {
      return {
        auditLogEntryID: auditLogEntity.auditLogEntryID,
        timestamp: auditLogEntity.timestamp,
        logMessage: auditLogEntity.logMessage,
        auditLogType: auditLogEntity.auditLogType
      };
    }
  )
);



// WEBPACK FOOTER //
// ./src/auditLog/formattedAuditLog.ts